import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import { Redirect } from 'react-router'
import { getLoginIfCustom, getDomainIfCustom } from 'context/AppContext'
import { getPhotographerByLogin, getPhotographerByDomain } from 'apiCalls/PhotographerRequests'
import { SpinLoaderFullScreen } from 'components/Loader/SpinLoaderFullScreen'
import { appEnvironment } from 'configs'

const PublicPackage = React.lazy(() => import('./PublicPackage'))
const PublicPortfolio = React.lazy(() => import('./PublicPortfolio'))
const PublishedGallery = React.lazy(() => import('./galleries/PublishedGallery'))
const Marketplace = React.lazy(() => import('./Marketplace'))
const PayBooking = React.lazy(() => import('./booking/PayBooking'))
const BookingCalendar = React.lazy(() => import('./booking-calendar/BookingCalendar'))
const MarketplacePackage = React.lazy(() => import('./marketplace/MarketplacePackage'))
const MarketplacePortfolio = React.lazy(() => import('./marketplace/MarketplacePortfolio'))
//const MagicCarpet = React.lazy(() => import('./magiccarpet/MagicCarpet'))
//const MagicCarpetCategory = React.lazy(() => import('./magiccarpet/MagicCarpetCategory'))
//const MagicCarpetCityCategory = React.lazy(() => import('./magiccarpet/MagicCarpetCityCategory'))
//const MagicCarpetCity = React.lazy(() => import('./magiccarpet/MagicCarpetCity'))
const EditWebsite = React.lazy(() => import('components/public/website/EditWebsite'))
const CreateWebsite = React.lazy(() => import('components/public/website/CreateWebsite'))
const PublicWebsiteDashboard = React.lazy(() => import('components/public/website/PublicWebsiteDashboard'))

const PublicRoutes = (props) => {
  const hasCustomDomain =
    window.location.hostname !== 'app.bookfocal.com' &&
    window.location.hostname !== 'app.dev.bookfocal.com' &&
    window.location.hostname !== 'localhost'

  if (window.location.pathname === '/' && hasCustomDomain) {
    ;(async function () {
      let photographer

      if (getLoginIfCustom()) {
        photographer = await getPhotographerByLogin(getLoginIfCustom())
      }

      if (getDomainIfCustom()) {
        photographer = await getPhotographerByDomain(getDomainIfCustom())
      }

      if (photographer) {
        props.history.push(`/portfolio/${photographer.identifier}`)
      }
    })()
  }

  // ENSURE THAT THERE ARE NO CUSTOM OR ODD DOMAINS IN MARKETPLACE URL
  useEffect(() => {
    if (
      !window.location.pathname.includes('/booking/') &&
      !window.location.pathname.includes('/portfolio/') &&
      !window.location.pathname.includes('/package/') &&
      !(window.location.pathname === '/')
    ) {
      if (appEnvironment === 'production') {
        if (window.location.hostname !== 'app.bookfocal.com') {
          window.location.hostname = 'app.bookfocal.com'
        }
      }
      if (appEnvironment === 'development') {
        if (window.location.hostname !== 'app.dev.bookfocal.com') {
          window.location.hostname = 'app.dev.bookfocal.com'
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return hasCustomDomain && window.location.pathname === '/' ? (
    <SpinLoaderFullScreen />
  ) : (
    <React.Fragment>
      <Content>
        <Switch>
          <Route path="/package/:identifier/:category?" component={PublicPackage} />
          <Route path="/portfolio/:identifier/:category?" component={PublicPortfolio} />
          <Route path="/booking-calendar/:identifier" component={BookingCalendar} />
          <Route path="/marketplace-package/:identifier/:category?" component={MarketplacePackage} />
          <Route path="/marketplace-portfolio/:identifier/:category?" component={MarketplacePortfolio} />
          <Route path="/marketplace/:searchParams?" component={Marketplace} />
          <Route path="/booking/:identifier" component={PayBooking} />
          <Route path="/gallery/:identifier" component={PublishedGallery} />
          <Route path="/creator" exact component={PublicWebsiteDashboard} />
          <Route path="/creator/new/:templateName" exact component={CreateWebsite} />
          <Route path="/creator/new/:templateName/edit" component={EditWebsite} />
          {/* <Route path="/explore-city/:city/:latitude/:longitude" component={MagicCarpetCity} />
          <Route
            path="/explore-city-category/:category/:city/:latitude/:longitude"
            component={MagicCarpetCityCategory}
          />
          <Route path="/explore-category/:category" component={MagicCarpetCategory} />
          <Route path="/explore" component={MagicCarpet} /> */}
          <Redirect from={'/'} to={'/marketplace'} />
        </Switch>
      </Content>
    </React.Fragment>
  )
}

export default PublicRoutes

const Content = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
`
